import { UI } from './ui';

export namespace SearchTexts {

  export enum VersionTypeHtml {
    ALLSERVERS = 'allservers',
    PCCLASSIC = 'pcclassic',
    PCMODS = 'pcmods',
    BEDROCK = 'bedrock',
    NEWSERVERS = 'newservers',
  }

  export const VersionTypeHtmlLabels: Record<string, string> = {
    [VersionTypeHtml.ALLSERVERS]: 'Все серверы',
    [VersionTypeHtml.PCCLASSIC]: 'PC Classic',
    [VersionTypeHtml.PCMODS]: 'PC Моды',
    [VersionTypeHtml.BEDROCK]: 'Bedrock',
    [VersionTypeHtml.NEWSERVERS]: 'Новые серверы',
  };

  // --- VersionMinecraft ---

  export interface McVersion {
    id: number;
    version: string;
  }

  export class McVersionForm extends UI.Form {
    id: number = null;
    version: UI.FormField;

    constructor(item?: McVersion) {
      super();
      this.id = item ? item.id : null;
      this.version = new UI.FormField(item ? item.version : '');
    }
  }

  // --- VersionDescriptionHtml ---

  export interface DescriptionHtml {
    id: number;
    title: string;
    description: string;
    t_header: string;
    t_text: string;
    b_header: string;
    b_text: string;
  }

  export class DescriptionHtmlForm extends UI.Form {
    id: number = null;
    title: UI.FormField;
    description: UI.FormField;
    t_header: UI.FormField;
    t_text: UI.FormField;
    b_header: UI.FormField;
    b_text: UI.FormField;

    constructor(item?: DescriptionHtml) {
      super();
      this.id = item ? item.id : null;
      this.title = new UI.FormField(item ? item.title : '');
      this.description = new UI.FormField(item ? item.description : '');
      this.t_header = new UI.FormField(item ? item.t_header : '');
      this.t_text = new UI.FormField(item ? item.t_text : '');
      this.b_header = new UI.FormField(item ? item.b_header : '');
      this.b_text = new UI.FormField(item ? item.b_text : '');
    }
  }

  // --- VersionDescription (join table) ---

  export interface VersionDescriptionItem {
    id: number;
    version: number;
    types: string;
    description: number;
    version_display?: string;
    description_display?: string;
  }

  export class VersionDescriptionForm extends UI.Form {
    id: number = null;

    constructor(item?: VersionDescriptionItem) {
      super();
      this.id = item ? item.id : null;
    }
  }

  // --- Лендинг-центричное представление (одна строка на тег) ---

  export enum LandingStatus {
    FILLED = 'filled',   // текст заполнен
    TODO = 'todo',       // t_text пустой или 'TODO'
    MISSING = 'missing', // у тега ещё нет строки (нужен перезапуск seed)
  }

  export const LandingStatusLabels: Record<string, string> = {
    [LandingStatus.FILLED]: 'Заполнен',
    [LandingStatus.TODO]: 'Не заполнен',
    [LandingStatus.MISSING]: 'Нет текста',
  };

  export interface LandingRow {
    tagId: number;
    name: string;                 // tag.name
    slug: string;                 // tag.value
    group: string;                // tag.group
    type: VersionTypeHtml;        // ожидаемый тип страницы (allservers | pcmods)
    url: string;                  // /slug или /pc-mods/slug
    status: LandingStatus;
    descriptionId: number | null; // id VersionDescriptionHtml для PATCH
    content: DescriptionHtml | null;
  }
}
